import DatabaseService from './DatabaseService.js'
import store from '../state/store.js';

class UserService {
	signIn(username, password, isPublicComputer) {
        return DatabaseService.signIn(username, password, isPublicComputer)
	}

    signUp(username, password, password2, code, isPublicComputer, profile) {
        if (password != password2) {
            return Promise.resolve( "Password and Confirm did not match." );
        }

        return DatabaseService.signUp(username,password,code,isPublicComputer,profile)
    }

    resetPassword(email)
    {
        if((typeof email) != "string")
            return Promise.reject( "E-mail must be a string." )
        
        return DatabaseService.requestPasswordReset(email.toLowerCase())
    }

	updateProfile(options) {
        return DatabaseService.updateProfile(options).then(function(result){ 
            //State.local.userProfile = result.userProfile;
            console.log("UserService.updateProfile", result.userProfile);
            store.dispatch({type:'SET_USER_PROFILE', userProfile:result.userProfile});
        });
    }

    fetchCompanyWelcome(){
		return DatabaseService.fetchCompanyWelcome().then(function(result){ 
            //State.local.companyWelcome = result.welcome
            store.dispatch({type:'SET_COMPANY_WELCOME', welcome:result.welcome});
        });

    }

    fetchPluginSyncUrl(pluginId, redirectUri) {
        return DatabaseService.fetchPluginSyncUrl(pluginId, redirectUri)
    }

    addUserPlugin(pluginId, data, clientKey) {
		return DatabaseService.addUserPlugin(pluginId, data, clientKey)
    }

    removeUserPlugin(pluginId) {
		return DatabaseService.removeUserPlugin(pluginId)
    }


    saveUserPhoto(photo)
    {
		return DatabaseService.updateProfile({
            userProfile : {
                avatar : {
                    dataURL : photo
                }
            }
        }).then(function(result) { 
            store.dispatch({type:'SET_USER_PROFILE', userProfile:result.userProfile});
            return result;
        });
    }

}

export default new UserService();



// WEBPACK FOOTER //
// ./src/services/UserService.js